import { useEffect } from "react";
import "./App.css";
import NewUI from "./components/App";
import { useTrackContext } from "./hooks/useTrackContext";
import { CREATE_CART } from "./graphqlQueries";
import { query } from "./lib";

interface IProps {
  componentType?: string;
  hostedAt?: string;
  isCustomerLogged?: boolean;
}

const App = (props: IProps) => {
  const { componentType, hostedAt, isCustomerLogged } = props;

  const { dispatch } = useTrackContext();

  const styles = {
    fontFamily: "'Montserrat', sans-serif",
  };

  const detectHostName = (url: string): string => {
    const urlObject = new URL(url);
    const hostParts = urlObject.host.split(".");

    if (hostParts.length >= 3 && hostParts[hostParts.length - 2] === "vercel") {
      // If the host has more than two parts and the second-to-last part is 'vercel'
      const subdomainParts = hostParts.slice(0, -2); // Exclude 'vercel' and the top-level domain
      return subdomainParts.join("-"); // Join the remaining parts with hyphens
    } else {
      // Otherwise, use a simplified logic for other cases
      const subdomain = hostParts[0].startsWith("www") ? hostParts[1] : hostParts[0];
      return subdomain || "";
    }
  };

  const hostName = detectHostName(window.location.href);
  // Create Cart
  useEffect(() => {
    (async ()=>{
      if (componentType !== "") {
        dispatch({
          type: "SET_PRODUCT_RENDER_LOCATION",
          payload: {
            productRenderedLocation: componentType as string,
          },
        });
      }
  
      if (hostedAt && hostedAt === "bosshunting") {
        dispatch({
          type: "SET_APP_HOSTED_AT",
          payload: {
            appHostedAt: hostedAt,
          },
        });
      }
  
      if (componentType !== "" && componentType === "external") {
        const cartCreated = await query(CREATE_CART, {
          input: {
            attributes: [{ key: "__source", value: hostName }],
          },
        });
        const { checkoutUrl, id } = cartCreated?.data?.cartCreate?.cart;
        if (checkoutUrl && id) {
          dispatch({
            type: "SET_CART_INFORMATION",
            payload: {
              cart: {
                id,
                checkoutUrl,
              },
            },
          });
        }
      }
  
      if (isCustomerLogged) {
        dispatch({
          type: "SET_IS_CUSTOMER_LOGGED_IN",
          payload: {
            isCustomerLogged: true,
          },
        });
      }
    })()
  }, [dispatch, componentType, hostName, hostedAt, isCustomerLogged]);

  return (
    <div className="tw-bg-black" style={styles}>
      <NewUI />
    </div>
  );
};

export default App;
